import * as yup from 'yup';

import { OpenDataDisputeForPositionFormFields } from '../types';

export const openDataDisputeValidationSchema = yup.object({
  [OpenDataDisputeForPositionFormFields.reason]: yup.string().required('Should enter a reason'),
});
